<template>
<v-card>
  <v-card-title v-if='record' class='pb-0 overline' >
    #{{record.id}}
  </v-card-title>

    <v-card flat >
      <v-card-text>
      <div v-if='record && record.patient' >
      Billing address: {{record.patient.billing_address || 'n/a' }}<br/>
      Birthday: {{ record.patient.date_of_birth }}<br/>
      </div>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <medical-aid-card
      v-if='record.medical_aid'
      v-model='record.medical_aid' >
    </medical-aid-card>

</v-card>
</template>
<script>
import MedicalAidCard from '@/components/cards/MedicalAidCard'

export default {
  name: 'RecordCard',
  components: {MedicalAidCard},
  props: {
    recordId: { required: false },
    value: { type: Object }
  },
  computed: {
    record () {
      if (this.value) {
        return this.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RecordCard.vue?e3a4f120